// extracted by mini-css-extract-plugin
module.exports = {"basicCard":"BasicCard_basicCard__1TnMW"};